import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as inventoryApi from '../../lib/api/inventory';


const [LIST_INV_HISTORY, LIST_INV_HISTORY_SUCCESS, LIST_INV_HISTORY_FAILURE] =
    createRequestActionTypes('inventory/LIST_INV_HISTORY');
export const listInventoryHistory = createAction(
    LIST_INV_HISTORY,
    (searchData) => searchData,
);
const listInventoryHistorySaga = createRequestSaga(
    LIST_INV_HISTORY,
    inventoryApi.getInventoryHistory,
);

const UNLOAD_INV_HISTORY = 'inventory/UNLOAD_INV_HISTORY';
export const unloadInventoryHistory = createAction(UNLOAD_INV_HISTORY);

export function* invHistorySaga() {
    yield takeLatest(LIST_INV_HISTORY, listInventoryHistorySaga);
}

const initialState = {
    history: null,
    error: null,
};

//data.list에 whUuid 포함..
const invHistory = handleActions(
    {

        [LIST_INV_HISTORY_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            history: data.list.map((trn) => ({
                id: trn.trnUuid,
                trnUuid: trn.trnUuid,
                trnTyp: trn.trnTyp,
                trnNm: trn.trnNm,
                trnFromWh: trn.trnFromWh,
                trnToWh: trn.trnToWh,
                trnDesc: trn.trnDesc,
                crtUsr: trn.crtUsr,
                crtNm: trn.crtNm,
                crtDt: trn.crtDt,
            })),
            error: null,
        }),
        [LIST_INV_HISTORY_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
        [UNLOAD_INV_HISTORY]: () => initialState
    },
    initialState,
);

export default invHistory